import { NavBarContainer } from "./nav-bar-profile.container";

export default NavBarContainer;
